import { useMediaQuery, useTheme } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router';

import { useCurrentPage } from '»utils/customHooks';

import BFACMBgLoginPage from '../../../assets/img/BFACM_bg-login.webp';
import BFACMBgLPage from '../../../assets/img/BFACM_bg-lpage.webp';
import { GradientContainer, TextContainer } from '../AppCard.styles';
import {
  BackgroundMobileImageStyled,
  BoxBackgroundImageStyled,
  CardContainer,
  LandingPageText,
} from './AppCardBFACM.styles';

export const AppCardBFACM = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const location = useLocation();

  const { isNoAuthFormPage, isLoginPage, isOnboardingAdvancedSteps } =
    useCurrentPage(location.pathname);

  if (isDesktop)
    return (
      <BoxBackgroundImageStyled
        isFormPage={isNoAuthFormPage}
        isLoginPage={isLoginPage}
        isOnboardingAdvancedSteps={isOnboardingAdvancedSteps}
      >
        <GradientContainer
          isOnboardingAdvancedSteps={isOnboardingAdvancedSteps}
        >
          <TextContainer isFormPage={isNoAuthFormPage}>
            <LandingPageText isFormPage={isNoAuthFormPage}>
              <FormattedMessage id="TRLT_UI-LANDING_PAGE_SLOGAN_BFACM" />
            </LandingPageText>
          </TextContainer>
        </GradientContainer>
      </BoxBackgroundImageStyled>
    );

  return (
    <CardContainer isFormPage={isNoAuthFormPage}>
      <LandingPageText isFormPage={isNoAuthFormPage}>
        <FormattedMessage id="TRLT_UI-LANDING_PAGE_SLOGAN_BFACM" />
      </LandingPageText>
      <BackgroundMobileImageStyled
        alt="background-mobile-image"
        component="img"
        src={isLoginPage ? BFACMBgLoginPage : BFACMBgLPage}
        isFormPage={isNoAuthFormPage}
      />
    </CardContainer>
  );
};
